import { Box, Typography } from "@mui/material";
import { useDesignTokens } from "../../theme/useDesignTokens";

const FormSection = ({
  title,
  description,
  compact = false,
  variant = "default",
  children,
}) => {
  const { colors, font } = useDesignTokens();
  const isPage = variant === "page";
  const isCompactPage = isPage && compact;
  const borderColor = colors?.ghost?.light || "#E0E0E0";
  const accentColor = colors?.primary?.main || "#ED6C02";

  return (
    <Box
      sx={{
        border: `1px solid ${borderColor}`,
        borderRadius: 1.5,
        bgcolor: isPage ? "#fff" : "#FAFAFA",
        overflow: "visible",
        mb: isCompactPage ? 0.875 : isPage ? 2 : compact ? 1.5 : 2.5,
        boxShadow: isPage ? "none" : undefined,
      }}
    >
      <Box
        sx={{
          px: isCompactPage ? { xs: 1.25, md: 1.5 } : isPage ? { xs: 2, md: 2.5 } : compact ? 1.5 : 2.5,
          py: isCompactPage ? 0.75 : isPage ? 1.5 : compact ? 1 : 1.5,
          borderBottom: `1px solid ${borderColor}`,
          bgcolor: isPage ? "grey.50" : "#fff",
          borderLeft: isPage ? `3px solid ${accentColor}` : undefined,
        }}
      >
        <Typography
          variant={isCompactPage ? "subtitle2" : isPage ? "subtitle1" : "subtitle2"}
          sx={{ fontWeight: font?.weight?.fontW700 || 700, color: "text.primary" }}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.25 }}>
            {description}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          p: isCompactPage ? { xs: 1.25, md: 1.5 } : isPage ? { xs: 2, md: 2.5 } : compact ? 1.5 : 2.5,
          display: "flex",
          flexDirection: "column",
          gap: isCompactPage ? 0.75 : isPage ? 2 : compact ? 1.25 : 2,
          width: "100%",
          minWidth: 0,
          maxWidth: "100%",
          boxSizing: "border-box",
          overflow: "visible",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default FormSection;
